// extracted by mini-css-extract-plugin
export default {"submit":"kHtNzw7zF0EckPKk5evG","buttonHolder":"fzvNQZBw0ntMy3KbPeT6","resetCard":"xSA_rXGxar12vhIlHtbK","footer":"n4XGgepwTNml4doUTt5e","question":"gDyZpbPPuYypsRxX3WB_"};